import { Button } from 'antd'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import $t from '../../../../i18n'
import Dialog from '../../../common/Dialog'
import Actions from '../../../../actions'
import { routes } from '../../../../consts'
import {
  getNumberTasksCompletedInPromoPeriod,
  isTaskCompleted,
  getPromoExpireDate,
  getDaysLeftUntilPromoExpire,
} from '../../../../utils/onBoardingUtils'
import {
  COMPLETED_HEALTH_HISTORY,
  ON_BOARDING_COMPLETE_TASK_REWARD,
  TASKS_REQUIRED_TO_MVP,
  DOWNLOAD_APP,
} from '../../../../consts/OnBoardingConsts'
import { getIsHmoMember } from '../../../../utils/hmoUtils'
import welcomeHmo from '../../../../resources/welcomeHmo.png'

import './HmoWelcomeDialog.css'

const HmoWelcomeDialog = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector(state => state.profile?.userDetails)
  const isHmoMember = getIsHmoMember(userDetails)
  const patientTasks = userDetails?.hmo_data?.on_boarding_tasks
  const enrollmentDate = userDetails?.hmo_data?.enrollment_date

  const promoPeriodDateExpire = getPromoExpireDate(enrollmentDate)
  const daysLeft = getDaysLeftUntilPromoExpire(promoPeriodDateExpire)

  const numberOfCompletedTasksInPromoPeriod =
    getNumberTasksCompletedInPromoPeriod(patientTasks, promoPeriodDateExpire)

  const [isClosed, setIsClosed] = useState(false)
  const isDownloadApp = isTaskCompleted(patientTasks, DOWNLOAD_APP.name)
  const isCompleteHealthHistoryForm = isTaskCompleted(
    patientTasks,
    COMPLETED_HEALTH_HISTORY.name
  )
  const isHmoWelcomeDialogNeedToBeVisible = useSelector(
    state => state.app.isHmoWelcomeDialogNeedToBeVisible
  )
  //Show welcome dialog only if the user is HMO member, the promo period is not expired,
  // the user didn't close the dialog and the user didn't complete the required tasks
  const isWelcomeDialogVisible =
    isHmoMember &&
    promoPeriodDateExpire > new Date() &&
    !isClosed &&
    isHmoWelcomeDialogNeedToBeVisible &&
    numberOfCompletedTasksInPromoPeriod < TASKS_REQUIRED_TO_MVP

  const onContinue = () => {
    dispatch(Actions.createAction(Actions.RISK_ASSESMENT_BOT_STARTED))
    dispatch(
      Actions.createAction(Actions.NAVIGATED_TO, routes.RISK_ASSESSMENT_BOT)
    )
    dispatch(Actions.createAction(Actions.HMO_WELCOME_DIALOG_CLOSED))
  }
  const onCancel = () => {
    setIsClosed(true)
    dispatch(Actions.createAction(Actions.HMO_WELCOME_DIALOG_CLOSED))
  }

  const getTitle = () => {
    if (!isDownloadApp && !isCompleteHealthHistoryForm) {
      return $t('hmoWelcomeDialog.titleNoneTasks')
    } else if (!isDownloadApp && isCompleteHealthHistoryForm) {
      return $t('hmoWelcomeDialog.titleHealthHistory')
    } else if (isDownloadApp && !isCompleteHealthHistoryForm) {
      return $t('hmoWelcomeDialog.titleDownloadApp', {
        firsrName: userDetails?.firstName,
      })
    }
  }

  const hmoWelcomeActions = [
    <Button
      key="1"
      data-hidden={isCompleteHealthHistoryForm}
      className="dialog-action trackable"
      data-name="getStartedButton"
      type="primary"
      onClick={() => {
        onContinue()
      }}
    >
      {$t('hmoWelcomeDialog.getStarted')}
    </Button>,
    <Button
      key="2"
      className="dialog-action trackable"
      data-name="closeButton"
      type={isCompleteHealthHistoryForm ? 'primary' : 'secondary'}
      onClick={() => {
        onCancel()
      }}
    >
      {$t('common.close')}
    </Button>,
  ]

  return (
    <Dialog
      title={getTitle()}
      isVisible={isWelcomeDialogVisible}
      footerActions={hmoWelcomeActions}
      onCancel={onCancel}
      className="hmo-welcome-dialog"
      image={welcomeHmo}
    >
      <div className="subtitle">
        {!isDownloadApp &&
          !isCompleteHealthHistoryForm &&
          $t('hmoWelcomeDialog.messages.noneTasks', {
            days: daysLeft,
            totalReward:
              ON_BOARDING_COMPLETE_TASK_REWARD * TASKS_REQUIRED_TO_MVP,
          })}
        {isDownloadApp &&
          !isCompleteHealthHistoryForm &&
          $t('hmoWelcomeDialog.messages.downloadAppCompleted', {
            days: daysLeft,
            totalReward:
              ON_BOARDING_COMPLETE_TASK_REWARD * TASKS_REQUIRED_TO_MVP,
          })}
        {!isDownloadApp &&
          isCompleteHealthHistoryForm &&
          $t('hmoWelcomeDialog.messages.healthHistoryCompleted', {
            days: daysLeft,
            reward: ON_BOARDING_COMPLETE_TASK_REWARD,
            totalReward:
              ON_BOARDING_COMPLETE_TASK_REWARD * TASKS_REQUIRED_TO_MVP,
          })}
      </div>
    </Dialog>
  )
}

export default HmoWelcomeDialog
